import { AttachmentsTypes } from './actionTypes';

export const getAttachments = (data: any) => ({
  type: AttachmentsTypes.GET_ATTACHMENTS,
  payload: data,
});

export const getAttachmentsSuccess = (data: any) => ({
  type: AttachmentsTypes.GET_ATTACHMENTS_SUCCESS,
  payload: data,
});

export const getAttachmentsFail = (error: any) => ({
  type: AttachmentsTypes.GET_ATTACHMENTS_FAIL,
  payload: error,
});

export const getOneAttachment = (data: any) => ({
  type: AttachmentsTypes.GET_ONE_ATTACHMENT,
  payload: data,
});

export const getOneAttachmentSuccess = (data: any) => ({
  type: AttachmentsTypes.GET_ONE_ATTACHMENT_SUCCESS,
  payload: data,
});

export const getOneAttachmentFail = (error: any) => ({
  type: AttachmentsTypes.GET_ONE_ATTACHMENT_FAIL,
  payload: error,
});
